var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgElimina = function SvgElimina(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-remove-circle-outline",
    "data-name": "Icon ionic-ios-remove-circle-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3613",
    "data-name": "Path 3613",
    d: "M50,7.16A42.63,42.63,0,1,1,19.71,19.7,42.85,42.85,0,0,1,50,7.16M50,.5A49.5,49.5,0,1,0,99.5,50,49.5,49.5,0,0,0,50,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-bin",
    "data-name": "Icon metro-bin",
    d: "M33.29,39.73V70.67a3.11,3.11,0,0,0,3.1,3.09H64.23a3.11,3.11,0,0,0,3.1-3.09V39.73Zm9.28,27.83H39.48V45.92h3.09Zm6.19,0H45.67V45.92h3.09Zm6.19,0H51.86V45.92H55Zm6.19,0H58V45.92h3.1Zm7-37.12H58V26.58a2.32,2.32,0,0,0-2.32-2.32H44.9a2.34,2.34,0,0,0-2.33,2.32v3.87h-10a2.33,2.33,0,0,0-2.32,2.32v3.86H70.42V32.77a2.33,2.33,0,0,0-2.32-2.32ZM55,30.45H45.67V27.39H55Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgElimina, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/elimina.fd19fac4.svg";
export { ForwardRef as ReactComponent };